'use client';

import LabelBadge from '@/shared/components/LabelBadge';

export type UserType = 'USER' | 'ADMIN-USER' | 'SUPER-USER' | 'IDENTITY-USER';

interface UserTypeBadgeProps {
  type: UserType;
}

const USER_TYPE_DISPLAY: Record<UserType, string> = {
  USER: 'User',
  'ADMIN-USER': 'Admin User',
  'SUPER-USER': 'Super User',
  'IDENTITY-USER': 'Identity User',
};

const UserTypeBadge = ({ type }: UserTypeBadgeProps) => {
  const getTagColor = (type: UserType) => {
    switch (type) {
      case 'USER':
        return 'blue';
      case 'ADMIN-USER':
        return 'purple';
      case 'SUPER-USER':
        return 'red';
      case 'IDENTITY-USER':
        return 'successful';
      default:
        return 'gray';
    }
  };

  return <LabelBadge color={getTagColor(type)}>{USER_TYPE_DISPLAY[type]}</LabelBadge>;
};

export default UserTypeBadge;
